
import { isLangRtl } from "@moderrotech/servers-communication-library/src/helpers/lang";
import _ from "lodash";
import { computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";

export enum ModalPosition {
  center,
  mobileBottom
}

export enum ModalSize {
  sm,
  md,
  lg
}

export default {
  props: {
    closeButtonVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    position: ModalPosition,
    size: ModalSize
  },
  setup(props: object) {
    const store = useStore();
    const config = computed(() => store.state.config.config);

    onMounted(() => document.body.classList.add("mdr-modal-open"));

    onUnmounted(() => document.body.classList.remove("mdr-modal-open"));

    return {
      config,
      isLangRtl,
      ModalPosition,
      ModalSize,
      positionAlpha: computed(() =>
        _.kebabCase(
          _.find(
            _.entries(ModalPosition),
            ([key, val]) => val === _.get(props, "position")
          )?.[0]
        )
      ),
      sizeAlpha: computed(() =>
        _.kebabCase(
          _.find(
            _.entries(ModalSize),
            ([key, val]) => val === _.get(props, "size", ModalSize.md)
          )?.[0]
        )
      ),
      ...props
    };
  }
};
